import { Button } from '@mui/material'
import React, { useState } from 'react'
import { useTranslate } from 'react-admin'

export const MonthlyFrequenciesDialog = ({frequencies, handleFormChange, setOpenMonthlyDialog}) => {
    const translate = useTranslate()
    const onSelectFrequency = (frequency) =>{
        let auxFrequencies = [...frequencies]
        if(frequencies.includes(frequency)){
            auxFrequencies = auxFrequencies.filter(freq=>freq!==frequency)
        } else {
            auxFrequencies.push(frequency)
        }
        handleFormChange('frequency',auxFrequencies)
    }
  return (
    <div style={{padding:'15px'}}>
        <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', width:'280px', justifySelf:'center'}}>
        {
            Array.from({ length: 30 }, (_, i) => (
                <div style={{
                    width:'30px', 
                    height:'30px',
                    margin:'5px',
                    borderRadius:'7px',
                    justifyContent:'center',
                    display:'flex',
                    fontWeight:'bold',
                    alignItems:'center', 
                    cursor:'pointer',
                    backgroundColor:frequencies.includes(i+1) ? '#6079f7ff' :'rgb(234, 242, 243)'
                }}
                onClick={()=>onSelectFrequency(i+1)}
                >
                    {i + 1}
                </div>
            ))
        }
        </div>
        <div style={{marginTop:'15px'}}>
            <Button
                variant='contained'
                onClick={()=>setOpenMonthlyDialog(false)}
            >
                {translate('ra.action.close')}
            </Button>
        </div>
    </div>
  )
}